import { PostProcessorModule } from "i18next";

const showTextIds = (): PostProcessorModule => {
  return {
    type: "postProcessor",
    name: "showTextIds",
    process: function (
      value: string,
      key: string,
      options: any,
      translator: any
    ) {
      /* return manipulated value */
      // console.log("key", key, value);
      return `{{${key}}}: ${value}`;
    },
  };
};

export default showTextIds;
